export function getLetters(v: string) {
    if (!v) return '';
    return v
        .split(' ')
        .map((word: string) => word[0].toUpperCase())
        .join('');
}